import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'lib-profile-orders-skeleton',
  templateUrl: './profile-orders-skeleton.component.html',
  styleUrls: ['./profile-orders-skeleton.component.css']
})
export class ProfileOrdersSkeletonComponent implements OnInit {


  lang: string = 'en';

  constructor(
    private lang_s: LanguageService
  ) { }

  ngOnInit(): void 
  {

    this.set_lang();

  }


  set_lang()
  {
    this.lang = this.lang_s.get_site_active_lang_code();
  }


}
